<template>
  <footer class="footer-section">
    <div class="footer-container">
      <div class="footer-column">
        <!-- Kolom 1: Logo en beschrijving -->
        <h3 class="footer-logo">Tahdik Restaurant</h3>
        <p>The Crunch of Persia</p>

        <div class="social-media">
          <a
            href="https://www.facebook.com/TahdikRestaurant"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <font-awesome-icon icon="fa-brands fa-facebook-f" />
          </a>
          <a
            href="https://www.instagram.com/tahdikrestaurant/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <font-awesome-icon icon="fa-brands fa-instagram" />
          </a>
          <a
            href="whatsapp://send?phone=+31302021863&text=Hello%2C%20I%20would%20like%20to%20make%20a%20reservation."
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <font-awesome-icon icon="fa-brands fa-whatsapp" />
          </a>
        </div>
      </div>
      <div class="footer-column">
        <!-- Kolom 2: Openingstijden -->
        <h3>Openingstijden</h3>
        <ul>
          <li>Maandag en Dinsdag: Gesloten</li>
          <li>Woensdag: 16:00 - 22:00</li>
          <li>Donderdag: 16:00 - 22:00</li>
          <li>Vrijdag: 16:00 - 22:00</li>
          <li>Zaterdag: 16:00 - 22:00</li>
          <li>Zondag: 16:00 - 22:00</li>
        </ul>
      </div>
      <div class="footer-column">
        <!-- Kolom 3: Adres en info -->
        <h3>Contact & Info</h3>
        <p>
          <font-awesome-icon icon="location-dot" />
          <a
            class="map-link"
            href="https://maps.app.goo.gl/ZaxFRVLS4XzbMsML9"
            target="_blank"
            rel="noopener noreferrer"
          >
            Bartoklaan 21, 3533 JA Utrecht
          </a>
        </p>
        <p>
          <font-awesome-icon icon="mobile" />
          <a class="phone-link" href="tel:+31634161665">06 34 16 16 65</a>
          <br />
          <font-awesome-icon icon="phone" />
          <a class="phone-link" href="tel:+31302021863">031 30 20 21 863</a>
        </p>
        <p>
          <font-awesome-icon icon="envelope" />
          <a class="email-link" href="mailto:info@tahdik.nl">info@tahdik.nl</a>
        </p>
      </div>
    </div>
    <hr />
    <div class="footer-bottom">
      <p>&copy; {{ new Date().getFullYear()  }} Tahdik Restaurant &verbar; Alle rechten voorbehouden</p>
      <nav class="footer-nav">
        <router-link v-for="page in pages" :key="page.name" :to="page.path" exact>{{
          page.name
        }}</router-link>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer-Section",
  created() {},
  data() {
    return {};
  },
  props: {},
  methods: {},
};
</script>

<style scoped>
.footer-section {
  background-color: var(--accent-twee);
  color: var(--text-color-light);
  padding: 2rem 1rem;
  font-family: Poltawski Nowy, serif;
}

.footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  gap: 2rem;
}

.footer-column {
  flex: 1;
  min-width: 250px;
}

.footer-column h3 {
  color: var(--accent-orange);
  margin-bottom: 1rem;
  font-size: 1.7rem;
}

.footer-column p,
.footer-column li {
  margin-bottom: 0.5rem;
  line-height: 1.6;
  font-size: 1.1rem;
}

.footer-column ul {
  list-style: none;
  padding: 0;
}

.footer-logo {
  font-weight: bold;
  font-size: 1.8rem;
}

.footer-bottom {
  /* border-top: 1px solid var(--accent-gold); */
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 1rem;
}

.footer-bottom p {
  font-size: 1rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.5rem;
}

.footer-bottom nav {
  text-align: center;
}

.phone-link,
.email-link,
.map-link {
  margin-left: 0.5rem;
  color: var(--text-color-light);
  text-decoration: none;
}

.phone-link:hover,
.email-link:hover,
.map-link:hover {
  text-decoration: underline;
  color: var(--accent-gold);
}

.footer-column p .svg-inline--fa {
  color: var(--accent-gold);
}

.footer-nav {
  margin-top: 1.5rem;
  text-align: center;
}
.footer-nav a {
  margin: 0 1rem;
  color: var(--text-color-light);
  text-decoration: none;
  font-weight: 500;
  font-size: 1.1rem;
  text-transform: uppercase;
}
.footer-nav a:hover,
.footer-nav a.router-link-exact-active {
  color: var(--accent-gold);
}

hr {
  border: none;
  border-top: 1px solid var(--accent-gold);
  margin: 1.5rem 0;
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    text-align: center;
  }
  .footer-column {
    min-width: 100%;
    margin-bottom: 1.5rem;
  }
  .footer-bottom {
    grid-template-columns: 1fr;
  }

  hr {
    width: 80%;
    margin: 1rem auto;
  }
}
</style>
